import {
  CardActionArea,
  CardActions,
  CardContent,
  Typography,
} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import Card from 'baby-ui/foundation/Card'
import Rating from 'baby-ui/foundation/Rating'
import useStyles from './styles'

export default function ProductCardSkeleton() {
  const classes = useStyles()

  return (
    <Card>
      <CardActionArea>
        <Skeleton variant="rect" height={164} />
        <CardContent>
          <Typography variant="caption" color="textSecondary">
            <Skeleton />
          </Typography>
          <Typography variant="subtitle2" noWrap>
            <Skeleton />
          </Typography>
          <Rating value={0} />
          <Typography variant="subtitle2" component="p">
            <Skeleton width={50} />
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Skeleton
          className={classes.productCardSkeletonButton}
          height={31}
          variant="rect"
        />
      </CardActions>
    </Card>
  )
}
